import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { MainPage } from "./components/MainPage";
import { ChatPage } from "./components/ChatPage";
import { AffectGrid } from "./components/questionnaireComponents/AffectGrid";
import { PreQuestionnairePage } from "./components/PreQuestionnairePage";
import { PostQuestionnairePage } from "./components/PostQuestionnairePage";
import { FreeChatPage } from "./components/FreeChatPage";
import { FreeChatPageC } from "./components/FreeChatPageC";
import { FooterNav } from "./components/FooterNav";
import { SettingsMenu } from "./components/SettingsMenu";
import { AddToHomeScreenIos } from "./components/pwaComponents/AddToHomeScreenIos";
import { AddToHomeScreenANdroid } from "./components/pwaComponents/AddToHomeScreenAndroid";
import { HistoryPage } from "./components/HistoryPage";
import { RemindingEventPage } from "./components/RemindingEventPage";
import { useAuth } from "./context/AuthContext";
import { ManualPage } from "./components/manualComponents/ManualPage";
import { ContactPage } from "./components/contactComponents/ContatPage";
import { ChatDescriptionPage } from "./components/utility/ChatDescriptionPage";
import { AdminPage } from "./components/AdminPage";
import { DebugPrePage } from "./components/questionnaireComponents/DebugPrePage";
import { DebugPostPage } from "./components/questionnaireComponents/DebugPostPage";

export const Routing = () => {
  const { idToken, refreshAuthSession } = useAuth();
  if (!idToken) return null;
  return (
    <>
      <Router>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100dvh", // ← 追加
            minHeight: 0, // ← 追加
            // maxHeight: "100vh",
            paddingTop: "env(safe-area-inset-top)", // ノッチ対応
            paddingBottom: "env(safe-area-inset-bottom)", // ホームインジケーター対応
          }}
        >
          <div
            style={{
              flex: 1,
              // overflow: "hidden",
              paddingBottom: "56px",
              // backgroundColor: "#FCFCFC",
            }}
          >
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/free" element={<FreeChatPageC />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route
                path="/pre-questionnaire"
                element={<PreQuestionnairePage />}
              />
              <Route
                path="/post-questionnaire"
                element={<PostQuestionnairePage />}
              />
              <Route path="/settings" element={<SettingsMenu />} />
              <Route path="/how-to-add-ios" element={<AddToHomeScreenIos />} />
              <Route
                path="/how-to-add-other"
                element={<AddToHomeScreenANdroid />}
              />
              <Route path="/remindEvent" element={<RemindingEventPage />} />
              <Route path="/manual" element={<ManualPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/chat-manual" element={<ChatDescriptionPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/debug-pre" element={<DebugPrePage />} />
              <Route path="/debug-post" element={<DebugPostPage />} />
            </Routes>
          </div>
          <FooterNav />
        </div>
      </Router>
    </>
  );
};
